import { useEffect, useState } from 'react';

import adjustmentService from '../../../../domain/services/solicitation/faciliter.adjustment.service';
import { messageOf } from './adjustment.catalog.constants';

export default function useAdjustmentCatalog({ isOpen, requestId, responsibleId, onLoadStart }) {

    const [state, setState] = useState({ isLoading: false, catalog: [], applied: [], pieceOptions: [], loadError: null });
    const [selectedGroup, setSelectedGroup] = useState(null);

    useEffect(() => {
        if (!isOpen) return;

        setState(current => ({ ...current, isLoading: true, loadError: null }));
        onLoadStart();

        adjustmentService
            .findCatalog(requestId, responsibleId)
            .then((response) => {
                const catalog = (response && response.catalog) || [];
                setState({
                    isLoading: false, catalog,
                    applied: (response && response.applied) || [],
                    pieceOptions: (response && response.pieceOptions) || [],
                    loadError: null
                });
                setSelectedGroup(catalog.length ? catalog[0].groupKey : null);
            })
            .catch((requestError) => setState({
                isLoading: false, catalog: [], applied: [], pieceOptions: [],
                loadError: messageOf(requestError, 'Não foi possível carregar os itens de ajuste.')
            }));
    }, [isOpen, requestId, responsibleId, onLoadStart]);

    return { ...state, selectedGroup, setSelectedGroup };
}
